import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { packageForMyBookingFunc } from '../../AdminPackageDetails/PackageShowcase/commonFunction';

const styles = StyleSheet.create({
  headerContainer: {
    marginTop: 10,
    marginBottom: 10,
  },
  packageName: {
    fontSize: 9,
    color: '#374151', // text-gray-700
    marginBottom: 5,
    textAlign: 'left',
  },
  billTo: {
    fontSize: 11,
    fontWeight: 'bold',
    color: '#374151', // text-gray-700
    textAlign: 'left',
  },
});

const BillTo = ({ invoice }) => {
  const invoiceData = JSON.parse(invoice);
  const packageDetails = packageForMyBookingFunc(invoiceData?.child);

  return (
    <View style={styles.headerContainer}>
      {packageDetails.is_package && (
        <Text style={styles.packageName}>
          Package Name: {packageDetails.package_name}
        </Text>
      )}
      <Text style={styles.billTo}>Booking Details</Text>
    </View>
  );
};

export default BillTo;
